// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1__cg","cls2":"Configuration-cls2_d5s Configuration-cls1__cg"};